import { render, staticRenderFns } from "./WhatsappChatComponent.vue?vue&type=template&id=2978f604&scoped=true&"
import script from "./WhatsappChatComponent.vue?vue&type=script&lang=js&"
export * from "./WhatsappChatComponent.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappChatComponent.vue?vue&type=style&index=0&id=2978f604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2978f604",
  null
  
)

export default component.exports